exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".th {\n  font-size: 16px;\n  padding: 7px 10px;\n  background: lightslategrey;\n  color: #ffffff;\n}\n\nform .submit {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  right: -74px;\n  border-radius: 0 0 17px 17px;\n}\n\n.padding-2 div {\n  padding-left: 2px !important;\n  padding-right: 2px !important;\n}\n\n.text-green {\n  color: forestgreen;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/production/sne-pro/src/app/component/deposit/deposit.component.css
// module id = ../../../../../src/app/component/deposit/deposit.component.css
// module chunks = main